// @ts-check
/**
 * @prettier
 */

import { useEffect, useState } from 'react';

/**
 * @param {number} width - Image width
 * @param {number} height - Image height
 */
const getOrientation = (width, height) => {
  if (width > height) return 'landscape';
  if (width < height) return 'portrait';
  return 'even';
};

/**
 * Use this hook with an imgSrc to asynchronously get it's width, height, and orientation.
 * @param {string} imgSrc - Original source to take image from
 * @return {{ loading: boolean, width: number, height: number, orientation: 'landscape' | 'portrait' | 'even' | null }}
 */
const useImageOrientation = imgSrc => {
  const [loading, setLoading] = useState(true);
  const [width, setWidth] = useState(null);
  const [height, setHeight] = useState(null);
  const [orientation, setOrientation] = useState(null);
  useEffect(() => {
    setLoading(true);
    const image = new Image();
    image.src = imgSrc;
    const handleLoad = () => {
      setLoading(false);
      setWidth(image.naturalWidth);
      setHeight(image.naturalHeight);
      setOrientation(getOrientation(image.naturalWidth, image.naturalHeight));
    };
    image.addEventListener('load', handleLoad);
    return () => {
      image.removeEventListener('load', handleLoad);
    };
  }, [imgSrc]);
  return { loading, width, height, orientation };
};

export default useImageOrientation;



// WEBPACK FOOTER //
// ./src/helpers/hooks/useImageOrientation.js